import styled from 'styled-components';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import {
	PrimaryColor,
	DarkGreySidely2,
	LightGreySidely2,
	RedSidely,
	SidelyBlack,
	SurfaceColor
} from '../../styles/global/css/Utils';
import { DefaultInput } from '../../styles/global/css/GlobalInput';

export const RightContainer = styled.div`
    height: calc(100vh - 128px);
    background-color: ${SurfaceColor};
`;

export const ProfilePic = styled.div`
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
`;

export const UserPhoto = styled.img`
    height: 30px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
`;

export const UserList = styled.ul`
    list-style: none;
    padding: 0;
    height: 100%;
    overflow-y: auto;
    margin: 0;
`;

export const UserDescription = styled.li<{ width?: number, clickable?: boolean }>`
    justify-content: space-around;
    margin: 10px 0 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: ${p => p.width ?? 500}px;
    ${p => p.clickable ? 'cursor: pointer;' : ''}


    &:hover {
        ${p => p.clickable ? `background-color: ${LightGreySidely2};` : ''}
        ${p => p.clickable ? 'border-radius: 6px;' : ''}
    }
`;

export const Button = styled(DefaultButton) <{ margin?: string, buttonWidth?: number }>`
    margin: ${p => p.margin ?? ''};
    width: ${p => p.buttonWidth ?? ''}px;
    height: 37px;
`;

export const Close = styled.img`
    height: 30px;
    cursor: pointer;
`;

interface TableRowProps {
	cursor?: string
}

export const TableRow = styled.div<TableRowProps>`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${p => p.color ? p.color : DarkGreySidely2};
    cursor: ${p => p.cursor ?? 'auto'};
    &:focus-visible {
        border: none;
        outline: none;
    }

    &:focus {
        border: none;
        outline: none;
    }
`;

export const NameInput = styled.input<{ error: boolean }>`
    ${DefaultInput}
    margin: 10px 0 30px 0;
    ${p => p.error
		? `&, &:hover, &:focus { border-color: ${RedSidely}; }`
		: `&:hover { border-color: ${PrimaryColor}; }`}
`;

export const Title = styled.div<{ center?: boolean }>`
    color: ${SidelyBlack};
    font-weight: 600;
    font-size: 14px;
    text-align: ${p => p.center ? 'center' : ''};
`;
